import * as React from 'react'
function SvgReduce(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M34 18H6c-1.2 0-2 .8-2 2s.8 2 2 2h28c1.2 0 2-.8 2-2s-.8-2-2-2z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgReduce
